import { render } from "./Textarea.vue?vue&type=template&id=3bc2d45e&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"

import "./Textarea.vue?vue&type=style&index=0&id=3bc2d45e&lang=css"
import "./Textarea.vue?vue&type=style&index=1&id=3bc2d45e&scoped=true&lang=css"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc2d45e"]])

export default __exports__